__turbopack_context__.v({
  "addToCartWrapper": "YarnPDPContainer-module__-OJ6rq__addToCartWrapper",
  "blok-big-title": "YarnPDPContainer-module__-OJ6rq__blok-big-title",
  "blok-subtitle": "YarnPDPContainer-module__-OJ6rq__blok-subtitle",
  "blok-title": "YarnPDPContainer-module__-OJ6rq__blok-title",
  "closeButton": "YarnPDPContainer-module__-OJ6rq__closeButton",
  "collapsedSection": "YarnPDPContainer-module__-OJ6rq__collapsedSection",
  "header": "YarnPDPContainer-module__-OJ6rq__header",
  "image": "YarnPDPContainer-module__-OJ6rq__image",
  "mediaContainer": "YarnPDPContainer-module__-OJ6rq__mediaContainer",
  "mediaSlider": "YarnPDPContainer-module__-OJ6rq__mediaSlider",
  "previewBackdrop": "YarnPDPContainer-module__-OJ6rq__previewBackdrop",
  "showImages": "YarnPDPContainer-module__-OJ6rq__showImages",
  "yarnPreview": "YarnPDPContainer-module__-OJ6rq__yarnPreview",
});
